<template>
  <div class="new_vip">
    <div class="content">
      <PointSetting :fromPage="'newVip'"></PointSetting>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PointSetting from "@/views/apply/pointSetting/pointSetting_test"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
    }
  },
  components: {
    PointSetting
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  width: 100%;
  padding: 10px 15px;
  height: 100%;
  background: #fff;
  .content{
    background: #fff;
    overflow: auto;
    height: 100%;
  }
}
</style>